import { useEffect, useState } from "react";
import VMasker from "vanilla-masker";
import moment from "moment";

// Actions
import { doGetCallHistoryRequest } from "src/store/context/actions";

type CallHistoryStateType = {
  loading: boolean;
  callList: Array<any>;
  count: number;
};

function ItemHistory({ call, index }: { call: any; index: number }) {
  const [state, setState] = useState({
    closed: true,
  });

  return (
    <li className="border-b pb-5 pt-5">
      <div aria-label="visible" className="flex items-start justify-between">
        <div>
          <span className="text-base text-neutral-gray-600 dark:text-white font-bold">
            {call.uda_nome}
          </span>

          <small className="block text-sm text-neutral-gray-500">
            {call.aderente_nome}
          </small>
        </div>
        <button
          className="text-sm underline decoration-1 text-neutral-gray-500 dark:text-white"
          type="button"
          onClick={() => setState((s) => ({ ...s, closed: !s.closed }))}
        >
          {state.closed ? "Ver detalhes" : "Ocultar detalhes"}
        </button>
      </div>

      {!state.closed && (
        <div className="mt-3 bg-[#F7FAFF] infos flex flex-col gap-3 mb-5 p-5 rounded-lg">
          <div className="flex justify-between">
            <span className="flex grow flex-col text-sm text-neutral-gray-800">
              <span className="text-sm text-neutral-gray-600">Celular</span>
              {VMasker.toPattern(
                call.uda_celular.indexOf("+55") > -1
                  ? call.uda_celular.substring(3, call.uda_celular.length)
                  : call.uda_celular,
                "(99) 99999-9999"
              )}
            </span>

            <span className="flex grow items-end flex-col text-sm text-neutral-gray-800">
              <span className="text-sm text-neutral-gray-600">Serviço</span>
              {call.servico_nome}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="flex grow flex-col gap-1 text-sm text-neutral-gray-800">
              <span className="text-sm text-neutral-gray-600">
                Início / Fim
              </span>
              {moment(call.inicio_conferencia).format("hh:mm:ss")} /{" "}
              {call.fim_chamada && moment(call.fim_chamada).format("hh:mm:ss")}
            </span>

            <span className="flex grow items-end flex-col gap-1 text-sm text-neutral-gray-800">
              <span className="text-sm text-neutral-gray-600">Data</span>
              {moment(call.data_chamada).format("DD/MM/YY")}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="flex grow flex-col text-sm text-neutral-gray-800">
              <span className="text-sm text-neutral-gray-600">
                Intermediação
              </span>
              {call.tipo_canal}
            </span>

            <span className="flex grow items-end flex-col gap-1 text-sm text-neutral-gray-800">
              <span className="text-sm text-neutral-gray-600">
                Lig. Externa
              </span>
              {call.ligacao_externa.length
                ? call.ligacao_externa
                    .map((ce: any) => ce.numero_efetivo)
                    .join(" / ")
                : "Nenhum"}
            </span>
          </div>
        </div>
      )}
    </li>
  );
}

export default function CallHistory() {
  const [state, setState] = useState<CallHistoryStateType>({
    loading: false,
    callList: [],
    count: 0,
  });

  useEffect(() => {
    async function init() {
      const { data, success } = await doGetCallHistoryRequest();

      if (success) {
        setState((s) => ({
          ...s,
          callList: [...data.results],
          count: data.count,
          loading: false,
        }));
      } else {
        setState((s) => ({ ...s, loading: false }));
      }
    }

    init();
  }, []);

  return (
    <div className="min-h-0 flex flex-col" data-testid="search-users-side">
      <h2 className="text-2xl font-semibold mb-4 dark:text-white">
        Histórico de chamadas
      </h2>

      {/* Loading */}
      {state.loading ? (
        <div className="flex items-center text-base justify-center h-[200px] text-primary-blue-500 dark:text-white font-bold ">
          <span className="loader spinner-1 mr-2"></span> Carregando
        </div>
      ) : (
        <>
          {/* User list */}
          {state.callList.length > 0 && (
            <div className="flex flex-col min-h-0">
              <ul className="overflow-x-auto">
                {state.callList.map((call, index) => (
                  <ItemHistory key={index} call={call} index={index} />
                ))}
              </ul>
            </div>
          )}

          {state.callList.length === 0 && (
            <div className="flex items-center text-base justify-center h-[200px] text-neutral-gray-400 text-center font-semibold">
              Não encontramos nenhum resultado. <br /> Vamos tentar de novo?
            </div>
          )}
        </>
      )}
    </div>
  );
}
